import React from "react";

const VectorGrass = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="60"
            height="40"
            viewBox="0 0 60 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            {/* Grass Bush - Multiple Sharp Blades */}
            <g>
                {/* Darker blades in back */}
                <path d="M5 40 L8 25 L12 40 M20 40 L23 20 L28 40 M45 40 L48 28 L52 40" fill="#1B5E20" />

                {/* Main Green blades */}
                <path d="M0 40 L5 15 L12 40 M10 40 L18 10 L26 40 M30 40 L38 20 L46 40 M50 40 L55 25 L60 40" fill="#2E7D32" />

                {/* HIGHLIGHT BLADES */}
                <path d="M7 40 L12 28 L17 40 M35 40 L40 25 L45 40" fill="#81C784" stroke="#2E7D32" strokeWidth="0.5" />
            </g>
        </svg>
    );
};

export default VectorGrass;
